import React, { useCallback, useEffect } from 'react'
import {
    Button,
    Card,
    CardContent,
    Container,
    Paper,
    Typography,
} from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Layout from '../../components/Layout'
import { GET_ONE_DEFECTIVE_GROUP } from '../../store/types'
import {
    deleteDefectiveItemFromGroup,
    getOneDefectiveGroup,
} from '../../store/actions/defectiveGroupAction'
import { DELETE_CONFIRM } from '../../constants/form'
import { roleListId, roleType } from '../../config/roleList'
import { checkUserRole } from '../../common/checkUserRole'

const ItemList = ({ defectiveItem, itemId, handleDeleteItem }) => {
    const { userInfo } = useSelector((state) => state.auth)
    const { roleList } = useSelector((state) => state.user)
    return (
        <TableRow>
            <TableCell>{defectiveItem?.item?.itemSKU}</TableCell>
            <TableCell>
                {defectiveItem.defectiveType === 1 ? '+' : '-'}
                {defectiveItem.quantity}
            </TableCell>
            <TableCell>{defectiveItem.note}</TableCell>
            <TableCell style={{ width: '50px' }}>
                <Button
                    onClick={() =>
                        checkUserRole(
                            userInfo,
                            roleList,
                            roleListId.DEFECTIVE_ITEM,
                            roleType.DELETE
                        )
                            ? handleDeleteItem(defectiveItem.id, itemId)
                            : alert('Not Permit User')
                    }
                    size="small"
                    color="error"
                    variant="outlined"
                >
                    Delete
                </Button>
            </TableCell>
        </TableRow>
    )
}

const DefectiveGroup = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { id } = useParams()
    const { defectiveGroup } = useSelector((state) => state.defectiveGroup)
    useEffect(() => {
        dispatch(getOneDefectiveGroup(id))
        return () => {
            dispatch({
                type: GET_ONE_DEFECTIVE_GROUP,
                payload: null,
            })
        }
    }, [dispatch, id])

    const handleDeleteItem = useCallback(
        (iid, itemId) => {
            if (window.confirm(DELETE_CONFIRM)) {
                dispatch(deleteDefectiveItemFromGroup(iid, itemId, id))
            }
        },
        [dispatch, id]
    )
    return (
        <Layout>
            <Container>
                <div className="order-products-box">
                    <Button
                        variant="outlined"
                        color="success"
                        onClick={() => navigate(-1)}
                        style={{ marginBottom: '10px' }}
                    >
                        Back
                    </Button>
                </div>
                {defectiveGroup && (
                    <div>
                        <h2 style={{ marginTop: '20px', marginBottom: '20px' }}>
                            {defectiveGroup.groupName}
                        </h2>
                        <h3>{defectiveGroup.note}</h3>
                        {defectiveGroup?.defectiveitems?.length > 0 &&
                            defectiveGroup?.defectiveitems?.filter(
                                (item) => item.defectiveType === 1
                            )?.length > 0 && (
                                <Card
                                    style={{
                                        marginBottom: '30px',
                                        marginTop: '30px',
                                    }}
                                >
                                    <CardContent sx={{ height: '100%' }}>
                                        <Typography
                                            variant="h5"
                                            component="div"
                                        >
                                            Increase
                                        </Typography>

                                        <div>
                                            <TableContainer component={Paper}>
                                                <Table aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>
                                                                Item SKU
                                                            </TableCell>
                                                            <TableCell>
                                                                Quantity
                                                            </TableCell>
                                                            <TableCell>
                                                                Note
                                                            </TableCell>
                                                            <TableCell
                                                                style={{
                                                                    width: '50px',
                                                                }}
                                                            ></TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {defectiveGroup?.defectiveitems
                                                            ?.filter(
                                                                (item) =>
                                                                    item.defectiveType ===
                                                                    1
                                                            )
                                                            ?.map(
                                                                (
                                                                    defectiveItem
                                                                ) => (
                                                                    <ItemList
                                                                        defectiveItem={
                                                                            defectiveItem
                                                                        }
                                                                        itemId={
                                                                            defectiveItem
                                                                                ?.item
                                                                                ?.id
                                                                        }
                                                                        key={
                                                                            defectiveItem.id
                                                                        }
                                                                        handleDeleteItem={
                                                                            handleDeleteItem
                                                                        }
                                                                    />
                                                                )
                                                            )}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </div>
                                    </CardContent>
                                </Card>
                            )}
                        {defectiveGroup?.defectiveitems?.length > 0 &&
                            defectiveGroup?.defectiveitems?.filter(
                                (item) => item.defectiveType === 2
                            )?.length > 0 && (
                                <Card
                                    style={{
                                        marginBottom: '30px',
                                        marginTop: '30px',
                                    }}
                                >
                                    <CardContent sx={{ height: '100%' }}>
                                        <Typography
                                            variant="h5"
                                            component="div"
                                        >
                                            Decrease
                                        </Typography>

                                        <div>
                                            <TableContainer component={Paper}>
                                                <Table aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>
                                                                Item SKU
                                                            </TableCell>
                                                            <TableCell>
                                                                Quantity
                                                            </TableCell>
                                                            <TableCell>
                                                                Note
                                                            </TableCell>
                                                            <TableCell
                                                                style={{
                                                                    width: '50px',
                                                                }}
                                                            ></TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {defectiveGroup?.defectiveitems
                                                            ?.filter(
                                                                (item) =>
                                                                    item.defectiveType ===
                                                                    2
                                                            )
                                                            ?.map(
                                                                (
                                                                    defectiveItem
                                                                ) => (
                                                                    <ItemList
                                                                        defectiveItem={
                                                                            defectiveItem
                                                                        }
                                                                        itemId={
                                                                            defectiveItem
                                                                                ?.item
                                                                                ?.id
                                                                        }
                                                                        key={
                                                                            defectiveItem.id
                                                                        }
                                                                        handleDeleteItem={
                                                                            handleDeleteItem
                                                                        }
                                                                    />
                                                                )
                                                            )}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </div>
                                    </CardContent>
                                </Card>
                            )}
                    </div>
                )}
            </Container>
        </Layout>
    )
}

export default DefectiveGroup
